import { ErrorBoundary } from '@genial/components';
import React from 'react';

export const WithdrawalEmpty: React.FC = () => {
  return (
    <ErrorBoundary
      errorIconOrIllustration="NotFoundIllustration"
      errorMessage="Este cliente não possui solicitações de saque disponíveis."
      errorTitle="Você ainda não possui solicitações."
    />
  );
};
